import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { truncateFileName } from "@Shared/utils/helpers/text";
import SelectClassificationStep from "./select-classification-step.vue";
import SelectApplicationStep from "./select-application-step.vue";
import SelectFilesStep from "./select-files-step.vue";
import { getFileName } from "@Broker/js/custom/utils";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UploadFilesModal",
  components: {
    GenericModal,
    SimpleButton,
    SelectClassificationStep,
    SelectApplicationStep,
    SelectFilesStep
  },
  props: {
    applicationId: {
      type: [String, Number],
      default: ""
    },
    clientUsername: {
      type: String,
      required: true
    },
    uploading: {
      type: Boolean,
      default: false
    },
    uploadingSucceeded: {
      type: Boolean,
      default: true
    },
    files: {
      type: Array,
      default: () => []
    },
    selectedFiles: {
      type: Array,
      required: true
    },
    selectedClassification: {
      type: Object,
      default: () => ({})
    },
    currentClassification: {
      type: String,
      default: () => ""
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    fullMode: {
      type: Boolean,
      default: false
    },
    applications: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      modalOpened: false,
      selectedType: this.allowCreate ? null : "use-existing",
      currentStep: "select-classification"
    };
  },
  computed: {
    title() {
      return this.allowCreate ? this.$t("global.words.upload") : this.$t("global.words.move");
    },
    areSelectedFilesEmpty() {
      return isEmpty(this.selectedFiles);
    },
    canSubmit() {
      if (this.isSelectFilesCurrentStep) return !this.areSelectedFilesEmpty;
      if (this.isSelectApplicationCurrentStep) return !(this.areSelectedFilesEmpty || isEmpty(this.applicationId));
      return !(isEmpty(this.selectedFiles) || isEmpty(this.selectedClassification));
    },
    documentsInfo() {
      if (this.areSelectedFilesEmpty) return "";
      const images = document.querySelectorAll("img");
      images.forEach(img => {
        img.alt = "client-profile-img";
      });
      if (this.selectedFiles.length > 1) return this.$tc("documents.document", 3, {
        qty: this.selectedFiles.length
      });
      return truncateFileName(getFileName(this.selectedFiles[0]), 25);
    },
    isSelectFilesCurrentStep() {
      return this.currentStep === "select-files";
    },
    isSelectApplicationCurrentStep() {
      return this.currentStep === "select-application";
    },
    buttonText() {
      return this.isSelectApplicationCurrentStep ? this.$t("global.words.continue") : this.$t("documents.actionDocuments", {
        action: this.title
      });
    }
  },
  watch: {
    async uploading(value) {
      if (!value && this.modalOpened) {
        this.handleChange();
      }
    }
  },
  mounted() {
    this.setInitialStep();
  },
  methods: {
    handleChange(value = null, key = "selectedClassification") {
      const event = this.fullMode ? {
        key,
        value
      } : value;
      this.$emit("change", event);
    },
    handleSubmit() {
      if (this.isSelectFilesCurrentStep) {
        this.currentStep = "select-application";
        return;
      } else if (this.isSelectApplicationCurrentStep) {
        this.currentStep = "select-classification";
        return;
      }
      this.$emit("submit");
    },
    resetData() {
      this.selectedType = this.allowCreate ? null : "use-existing";
      this.setInitialStep();
      this.$emit("reset");
    },
    openModal() {
      this.$refs.organize.show();
      this.modalOpened = true;
    },
    closeModal() {
      if (this.modalOpened) {
        this.$refs.organize.hide();
        this.modalOpened = false;
        this.resetData();
      }
    },
    setInitialStep() {
      this.currentStep = this.fullMode ? "select-files" : "select-classification";
    },
    handleSelectFile({
      type,
      file
    }) {
      var _context;
      const files = type === "select" ? [...this.selectedFiles, file] : _filterInstanceProperty(_context = this.selectedFiles).call(_context, currentFile => currentFile.id !== file.id);
      this.handleChange(files, "selectedFiles");
    },
    handleSelectAllFiles({
      type
    }) {
      const files = type === "select" ? this.files : [];
      this.handleChange(files, "selectedFiles");
    }
  }
});